export enum QuestCategory {

    PreWorkUp = 0,
    FamilyVoucherScreening = 1
}